import React, { useEffect, useRef, forwardRef, useImperativeHandle, memo, useState, useCallback} from 'react';


import classNames from 'classnames';
import $ from 'jquery';
import logo  from "../../assets/image/logo.png"
import "./Player.scss"

const Player = forwardRef(({params, style, classname, eventLister}, ref) => {

  console.log(`player render: ${params.id}`)
  console.log(JSON.stringify(params))

  const jessRef = useRef(null)

  const playUIRef = useRef(null)
  // 播放状态
  const [playState, setPlayState] = useState(0)
  // 播放地址
  const playUrlRef = useRef(null)
  // jess 参数
  const jessParmsRef = useRef({})
  
  useEffect(() => {
    jessParmsRef.current = {
      ...jessParmsRef.current, 
      params
    }
  }, [params])

  const eventListerRef = useRef(null)
  useEffect(() => {
    eventListerRef.current = eventLister
  }, [eventLister])


  const initPlayer = useCallback(() => {
    playUIRef.current = new window.JessibucaPro({
        container: jessRef.current,
        decoder: "/jessibuca/decoder-pro.js",
        useMSE: true, //mse硬解码
        useWCS: true,
        useVideoRender: true,
        wasmUseVideoRender: true,
        autoWasm: true,
        isFlv: true,
        isResize: false,
        text: "",
        loadingIcon: false,
        controlAutoHide: false,//鼠标聚焦到播放器内部会显示操作栏
        loadingText: "",
        recordType: "mp4",//视频录制默认的格式，支持webm和mp4。
        debug: false,
        debugLevel: 'debug',
        audioEngine: "worklet",
        showBandwidth: true, // 显示网速
        operateBtns: {
          fullscreen: true,
          screenshot: true,
          performance: false,//性能面板开启
          play: true,
          audio: true,
          record: true,
          close: true
        },
        isNotMute: false,
        isWebrtcForOthers:true
      });

      playUIRef.current.on('close', () => {
        console.log("close")
        const params = jessParmsRef.current.params
        setTimeout(() => {//点击停止按钮
          if(params.hadUsed && playUrlRef.current && !!playUrlRef.current){
            setPlayState(0)
            eventListerRef.current && eventListerRef.current("stop", params)
          }
        }, 10);
      });
  }, [ params, eventListerRef.current])



  const handleClick = () => {
    eventListerRef.current && eventListerRef.current("click", params)
  }

  const handlePtz = (event) => {
    event.preventDefault()
    console.log("handlePtz", event)
    eventListerRef.current && eventListerRef.current("ptz", params)
  }

  const specifyPlayVideoH5 = (url) => {
    if(!url){
      alert("播放地址为空，无法播放！");
      return;
    }
    playUrlRef.current = url
    setTimeout(function () {
      if(params.name){
        initPlayer();
        playUIRef.current.play(url);
        setPlayState(1)
        if ($("#player"+params.id+" .jessibuca-controls-left").find(".theChannel")) {
          $("#player"+params.id+" .jessibuca-controls-left").find(".theChannel").remove();
        }
        let deviceHtml =`<div class="jessibuca-controls-item theChannel"></div>`;
        $("#player"+params.id+" .jessibuca-controls-bottom").find(".jessibuca-controls-left").prepend(deviceHtml);
      }else{
        eventLister("stop", params)
      }
    })
  }

  const closePlayH5 = async () => {//关闭指定播放
    console.log("关闭指定播放", params.id);
    playUIRef.current && await playUIRef.current.destroy()
    playUIRef.current = null
    setPlayState(0)
    // if (this.resendSTO) {
    //   clearTimeout(this.resendSTO);
    //   this.resendSTO = null;
    // }
    playUrlRef.current = ""
  }

  useImperativeHandle(ref, () => ({
    msg:"hello",
    focus: () => {
      console.log("focus");
    }, 
    closePlayH5,
    specifyPlayVideoH5,
  }));


  return (
    <div  id={"player" + params.id} onClick={handleClick} className={classNames("play-box column", classname)} style={style}>
      <div ref={jessRef} className="theplay" id={params.id}>
        <div 
          style={{position: 'absolute', fontSize: '12px',marginBottom: "6px", zIndex: 100, bottom: 0, color: 'white',display: 'flex', borderRadius: '4px', alignItems: 'center', justifyContent: 'center', right: '235px',padding: '4px 8px', textAlign: 'center', backgroundColor: '#f60', cursor: 'pointer'}} 
          className="jessibuca-controls-item theChannel ptz-btn-jessibuca"
          onClick={handlePtz}
        >
            云台
        </div>
      </div>
      {!playState  && (
        <div className="logo" >
          <img src={logo} alt="" />
        </div>
      )}
  </div>
  );
})


export default memo(Player)